<template>
  <div class="popUpMain" ref="popUpMain">
    <!-- <div class="timeoutCounter">Timeout: {{timeoutTime}}</div> -->
    <div class="timeoutMain" v-if="data['timeout'] <= 0">
      <div class="timeoutMsg">Booking Session timed out</div>
    </div>
    
    <div class=" verificationList">
      <div class="verificationMain" v-for="(vL, i) in data['verificationList']" :key="'veriMain' + i" :style="{
        'margin': (((i + 1) < data['verificationList']['length']) ? '0 5px 0 0' : '0 0 0 5px')}">
        <div class="verficationConNo">{{vL['consignmentNo']}}</div>
        <div class="verification" v-for="(v, i) in vL['items']" :key="'veri' + i">
          <div class="title">
            <div class="titleText" :style="{ 'color': (v['status'] ? (v['status'] == 'valid' ? 'green' : 'red') : 'orange') }">{{v['title']}}</div>
            <img class="titleIcon" v-if="v['status']" 
              :src="'https://dsmlib.logistics.systems/Icons/' + (v['status'] ? (v['status'] == 'valid' ? 'icons8-thumbs-up-96.png' : 'icons8-unlike-96.png') : '')"/>
          </div>
          <div class="data" v-for="(d, i2) in v['data']" :key="'data' + i2">{{d ? d : '-'}}</div>
        </div>
      </div>
    </div>

    <div class="body">
      <div class="left">
        <Input class="inputs" placeholder="Port / Depot" :isDisabled="true" :inputValue.sync="data['verificationReturn']['terminal']"/>
        <RemarksBox class="inputs" :text.sync="data['verificationReturn']['remarks']" :maxLength="200"/>
      </div>

      <div class="right">
        <Dropdown class="inputs" placeholder="Select Booking Slot" :items="portBTimeSlots" itemKey="desc" @selected="dropdownBtn('slot', $event)"
          :selectedObject.sync="data['verificationReturn']['slot']" :isRequired="true" :errorMessage="data['slotError']"/>
        <div class="timeslotMain" v-if="data['verificationReturn']['slot']">
          <div class="row">
            <div class="timeslot">
              <div class="title">Available Timeslots</div>
              <div class="value">{{data['verificationReturn']['slot']['available']}} slots</div>
            </div>
            <div class="timeslot">
              <div class="title">Timeslots Used</div>
              <div class="value">{{data['verificationReturn']['slot']['used']}} / {{data['verificationReturn']['slot']['total']}}</div>
            </div>
          </div>

          <div class="row">
            <div class="timeslot">
              <div class="title">Start Date/Time</div>
              <div class="value">{{data['verificationReturn']['slot']['start']}}</div>
            </div>
            <div class="timeslot">
              <div class="title">End Date/Time</div>
              <div class="value">{{data['verificationReturn']['slot']['end']}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Loader class="loaderMain" ref="loaderMain" style="height: 100%; top: 0px;" :isVisible="data['portBLoadShow']" :loadingText="data['portBLoadText']"/>
  </div>
</template>

<script>
  /* eslint-disable */
  import Dropdown from '@/components/Dropdown.vue';
  import RemarksBox from '@/components/RemarksBox.vue';


  export default {
    components: {
      Dropdown, RemarksBox
    },
    props: {
      //---- Main Props
      data: { type: Object, default: function () { return {} } },
      viewMode: { type: Boolean, default: false },
      errorFlag: { type: Boolean, default: false }, 
      
      //---- Load Props
      loadShow: { type: Boolean, default: false },
      loadText: { type: String, default: 'Loading' },
    },
    data() {
      return {
        portBDepot: '',

        portBTimeSlots: [],
      }
    },
    mounted() {
      this.loadData();
    },
    methods: {
      loadData: async function() {
        
      },
      
      dropdownBtn: async function(cmd, data) {
        switch(cmd) {
          case 'slot':
            
            break;
        }
      },
      
      //---- Utility Methods
      formatDatetoString: function (date) {
        if (typeof date == 'string') {
          //console.log(date);
          var dateF = date.replace(/\/Date\(/g, '').replace(/\)\//g, '').replace(/\-/g, '-');
          try {
            var dateFF = new Date(dateF);
            if (!(dateFF.getTime() === dateFF.getTime())) { dateFF = new Date(parseInt(dateF)); }
          } catch (e) { /*console.log(e);*/ }
        } else {
          var dateFF = date;
        }
        
        var d = ((dateFF.getDate().toString().length < 2) ? '0' : '') + dateFF.getDate().toString();
        var m = (((dateFF.getMonth() + 1).toString().length < 2) ? '0' : '') + (dateFF.getMonth() + 1).toString();
        var y = dateFF.getFullYear();
        var hh = ((dateFF.getHours().toString().length < 2) ? '0' : '') + dateFF.getHours().toString();
        var mm = ((dateFF.getMinutes().toString().length < 2) ? '0' : '') + dateFF.getMinutes().toString();

        return `${y}-${m}-${d} ${hh}:${mm}`;
      },
      formatStringtoDate: function (date) {
        var dateF = date.replace(/ /g, '/').replace(/\:/g, '/');
        var dateFF = dateF.split('/');
        return new Date(dateFF[0], (parseInt(dateFF[1]) - 1).toString(), dateFF[2], dateFF[3], dateFF[4]);
      },
    },
    computed: {
      verificationData() {
        return this.data['verificationData'];
      },

      timeoutTime() {
        return Math.floor(this.data['timeout'] / 60) + ':'+ (Math.floor(this.data['timeout'] % 60) < 10 ? '0' : '') + Math.floor(this.data['timeout'] % 60);
      },
    },  
    watch: {
      verificationData(data) { 
        if (data) {
        //---- Format Slots
          this.portBTimeSlots = [];
          data['timeslots']['slots'].forEach((s) => {
            this.portBTimeSlots.push({
              'total': s['total'],
              'start': s['start'],
              'end': s['end'],
              'used': s['used'],
              'available': s['available'],
              'desc': s['start'] + ' | ' + s['available'] + ' slots',
            });
          });
        }
        // console.log(this.portBTimeSlots);
        // this.portBTimeSlots = data['timeslots']['slots'];
      }
    },
  }
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

  .popUpMain {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    white-space: nowrap;

    > .body {
      width: 100%;
      height: auto;
      margin: 10px 0 0 0;
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      
      > .left {
        width: auto;
        height: 100%;
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
      }

      > .right {
        width: auto;
        height: 100%;
        flex: 1;
      }
    }

    .timeslotMain {
      width: auto;
      height: auto;
      max-width: 410px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;

      > .row {
        width: 100%;
        height: auto;
        display: flex;
        align-items: center;
        justify-content: space-between;

        > .timeslot {
          width: auto;
          height: 100%;
          flex: 1;
          padding: 4px;
          margin: 0 10px 10px 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-start;
          border-radius: 8px;
          box-shadow: 0 0 4px #0004;
          user-select: none;

          > .title {
            width: 100%;
            height: auto;
            margin: 0 0 5px 0;
            font-size: 12px;
            font-weight: bold;
          }
          
          > .value {
            width: 100%;
            height: auto;
            font-size: 12px;
          }
        }
      }
    }

    > .loaderMain {
      width: 100%;
      position: absolute;
      bottom: 0px;
      user-select: none;
    }
  }

  .verificationList {
    width: 100%; 
    height: auto;
    margin: 20px 0 0 0;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }
  
  .verificationMain {
    width: auto;
    height: auto;
    padding: 0 5px;
    flex: 1;
    position: relative;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-wrap: wrap;
    border: solid 1px #c4c4c4;
    border-radius: 8px;
    box-shadow: 0 0 4px #0004;

    > .verficationConNo {
      width: auto;
      height: 20px;
      padding: 0 5px;
      font-size: 12px;
      font-weight: bold;
      position: absolute;
      top: -20px;
      left: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: solid 1px #c4c4c4;
      border-bottom: none;
      border-radius: 4px 4px 0 0;
    }

    > .verification {
      width: auto;
      height: auto;
      padding: 5px 10px;
      margin: 5px 5px 5px 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      border: solid 1px #0002;
      border-radius: 4px;

      > .title {
        width: 100%;
        height: 30px;
        margin: 0 0 5px 0;
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        > .titleText {
          width: auto;
          height: 100%;
          font-weight: bold;
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: flex-start;
        }

        > .titleIcon {
          width: auto;
          height: 100%;
          margin: 0 0 0 10px;
        }
      }

      > .data {
        width: 100%;
        height: auto;
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
      }
    }
  }

  .inputs {
    width: 100%;
    max-width: 400px;
    max-height: 200px;
  }

  .timeoutCounter {
    width: auto;
    height: auto;
    padding: 0 4px;
    font-size: 14px;
    font-weight: bold;
    position: absolute;
    top: 0px;
    right: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;
  }

  .timeoutMain {
    width: auto;
    height: auto;
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #0004;
    z-index: 20;
  }

  .timeoutMsg {
    width: auto;
    height: auto;
    padding: 10px;
    font-size: 14px;
    font-weight: bold;
    background-color: #ffff;
    border-radius: 8px;
    user-select: none;
  }

</style>